import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation } from 'react-router-dom'
import style from './style.m.less'

export const routes = [
    { id: 1, to: 'main', title: 'header.main' },
    { id: 2, to: 'about', title: 'header.about' },
    { id: 3, to: 'documents', title: 'header.documents' },
    {
        id: 4,
        to: 'green-tools',
        title: 'header.greenTools',
        addUrls: ['certificates-in-pledge'],
        state: { fromMenu: true },
    },
    { id: 5, to: 'qualification', title: 'header.qualification' },
    { id: 6, to: 'news', title: 'header.news' },
    { id: 7, to: 'calculator', title: 'calculator.title' },
]

const Navigation: FC = () => {
    const { t } = useTranslation()
    const location = useLocation()

    const navTabs = routes.map((route) => {
        const { id, to, title, state } = route
        return (
            <NavLink
                className={(navData) => {
                    return navData.isActive ||
                        (route.to === 'main' && location.pathname === '/') ||
                        route.addUrls?.some((url: string) => location.pathname.includes(url))
                        ? style.navLinkActive
                        : style.navLink
                }}
                key={id}
                to={to}
                state={state}
            >
                {t(title)}
            </NavLink>
        )
    })

    return <nav className={style.navBar}>{navTabs}</nav>
}

export default Navigation
